import { ReactNode } from "react";
import { useAuthStore } from "../stores/authStore";
import { Navigate } from "react-router-dom";
import { PageLoader } from "./PageLoader";

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return <PageLoader />;
  }

  // Rediriger immédiatement sans rendu du contenu enfant
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
